import { Injectable } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import * as moment from 'moment';

@Injectable()
export class TimeUtils {

  constructor() { }

  public static dateLabel(date: Date, filter: any): string {
    let prefix: string = filter.range.toUpperCase();

    if (prefix == "FY") {
      prefix = "Last Updated";
    } else if (filter && filter.psd) {
      let psd: string = filter.psd;
      if (psd.charAt(0) == '-') {
        prefix = "Past " + psd.charAt(1) + " " + (psd.charAt(2) == 'W' ? "Weeks" : "Months") + " as ";
      }
    } else if (prefix == "DAY") {
      prefix = "";
    } else {
      prefix += " as";
    }

    return prefix.concat(' on ').concat(moment(date).format('DD MMM YYYY'));
  }

  public static relativeDate(filter: any, oper: string): void {
    try {
      let ped: Date = this.fromymd(filter.ped);

      let period: string = oper.charAt(0);
      let operand = oper.charAt(1).toUpperCase();
      let count = oper.charAt(2);

      let base_date = moment(ped);
      let to_date: any;
      let from_date: any;

      if (operand == "-") {
        to_date = moment(ped).subtract(count, 'M');
      } else {
        to_date = moment(ped).add(count, 'M');
      }
      filter.fped = to_date.format('YYYYMMDD');

      from_date = to_date.startOf('M');
      filter.fsed = from_date.format('YYYYMMDD');

    } catch (e) {
      console.error(e);
    }
  }

  public static toymd(date: Date): string {
    return moment.utc(date).format('YYYYMMDD');
  }

  public static toDate(date: string): Date {
    return moment.utc(date, 'YYYYMMDD').toDate();;
  }

  public static formatDate(date: Date): string {
    return moment.utc(date).format('MM/DD/YYYY');
  }

  public static fromymd(date: string): any {
    return moment.utc(date, 'YYYYMMDD');
  }
}



// WEBPACK FOOTER //
// ./src/app/bi/common/service/time.utils.ts